import React from 'react'

import Bugsnag from '@bugsnag/js'
import { connect } from 'react-redux'
import type { RootState } from 'reducers'

import { getBugsnagData } from '@albacross/frontend-utils'

export default (DecoratedComponent: React.ComponentType<any>) => {
  class ConnectedComponent extends React.Component<any> {
    static displayName = 'BugsnagMetaData'

    componentDidUpdate() {
      Bugsnag.addMetadata('custom', this.props.bugsnagData)
    }

    render() {
      const { bugsnagData, ...rest } = this.props

      return <DecoratedComponent {...rest} />
    }
  }

  return connect((s: RootState) => ({
    bugsnagData: getBugsnagData(s),
  }))(ConnectedComponent)
}
